import React from 'react'
import hultLogo from '../../assets/images/hult-logo.svg'
import './hult-power.scss'
import Container from '../container'

const HultPower = () => (
  <Container>
    <hr />
    <a href='https://www.hult.edu/' target='_blank' rel='noopener noreferrer'>
      <div className='hult-power row row--align-center'>
        <div className='row__column'>
          <p className='g--margin-none g--font-body'>Developed by</p>
        </div>
        <div className='row__column' href=''>
          <img className='hult-power__logo' src={hultLogo} alt={hultLogo} />
        </div> 
        <p className='g--margin-none g--font-body'>
          {' '}
          Market data from Burning Glass Technologies
        </p>
      </div>
      <div className='g--spacer hide--tablet' />
    </a>
  </Container>
)

export default HultPower
